<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    <defs>
        <path id="prefix__a" d="M13.499 10.966c.276 0 .5.225.5.5v2.037c0 .275-.224.5-.5.5H.505c-.276 0-.5-.223-.5-.5L0 11.468c0-.276.224-.5.5-.5zm0-5.483c.245 0 .45.177.492.41l.008.09V8.02c0 .246-.177.45-.41.492l-.09.008L.505 8.52c-.246 0-.45-.177-.492-.41l-.008-.089L0 5.984c0-.245.177-.45.41-.493l.09-.008h12.999zm0-5.483c.245 0 .45.177.492.41l.008.09v2.036c0 .246-.177.45-.41.492l-.09.008H.505c-.246 0-.45-.176-.492-.409l-.008-.09L0 .502C0 .255.177.05.41.008L.5 0h12.999z"/>
    </defs>
    <g fill="none" fill-rule="evenodd" transform="translate(5 5)">
        <mask id="prefix__b" fill="#fff">
            <use xlink:href="#prefix__a"/>
        </mask>
        <use fill="#000" xlink:href="#prefix__a"/>
        <path fill="#47454A" d="M-2 -2H16V16H-2z" mask="url(#prefix__b)"/>
    </g>
</svg>
